/* eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars */
import * as $protobuf from 'protobufjs/light'

const $root = ($protobuf.roots.default || ($protobuf.roots.default = new $protobuf.Root()))
  .addJSON({
    proto: {
      options: {
        go_package: '.;proto'
      },
      nested: {
        Job: {
          fields: {
            name: {
              type: 'string',
              id: 1
            },
            title: {
              type: 'string',
              id: 2
            },
            location: {
              type: 'string',
              id: 3
            },
            jobType: {
              type: 'string',
              id: 4
            },
            headCount: {
              type: 'string',
              id: 5
            },
            experience: {
              type: 'string',
              id: 6
            },
            salary: {
              type: 'string',
              id: 7
            },
            desc: {
              type: 'string',
              id: 8
            },
            id: {
              type: 'int32',
              id: 9
            },
            createTime: {
              type: 'string',
              id: 10
            }
          }
        },
        JobTitle: {
          fields: {
            title: {
              type: 'string',
              id: 1
            },
            status: {
              type: 'int32',
              id: 2
            },
            id: {
              type: 'int32',
              id: 3
            }
          }
        },
        News: {
          fields: {
            title: {
              type: 'string',
              id: 1
            },
            image: {
              type: 'string',
              id: 2
            },
            url: {
              type: 'string',
              id: 3
            },
            order: {
              type: 'int32',
              id: 4
            },
            id: {
              type: 'int32',
              id: 5
            },
            createTime: {
              type: 'string',
              id: 6
            }
          }
        },
        TSAdminCreateJobRequest: {
          fields: {
            job: {
              type: 'Job',
              id: 1
            }
          }
        },
        TSAdminCreateJobResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            id: {
              type: 'int32',
              id: 3
            }
          }
        },
        TSAdminDeleteJobRequest: {
          fields: {
            id: {
              type: 'int32',
              id: 1
            }
          }
        },
        TSAdminDeleteJobResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            }
          }
        },
        TSAdminUpdateJobRequest: {
          fields: {
            job: {
              type: 'Job',
              id: 1
            }
          }
        },
        TSAdminUpdateJobResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            job: {
              type: 'Job',
              id: 3
            }
          }
        },
        TSAdminListJobRequest: {
          fields: {
            pageNum: {
              type: 'int32',
              id: 1
            },
            pageSize: {
              type: 'int32',
              id: 2
            },
            jobTitle: {
              type: 'string',
              id: 3
            },
            location: {
              type: 'string',
              id: 4
            },
            jobType: {
              type: 'string',
              id: 5
            }
          }
        },
        TSAdminListJobResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            jobList: {
              rule: 'repeated',
              type: 'Job',
              id: 3
            },
            totalCount: {
              type: 'int32',
              id: 4
            }
          }
        },
        TSAdminDetailJobRequest: {
          fields: {
            id: {
              type: 'int32',
              id: 1
            }
          }
        },
        TSAdminDetailJobResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            job: {
              type: 'Job',
              id: 3
            }
          }
        },
        TSAdminCreateJobTitleRequest: {
          fields: {
            title: {
              type: 'string',
              id: 1
            }
          }
        },
        TSAdminCreateJobTitleResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            id: {
              type: 'int32',
              id: 3
            }
          }
        },
        TSAdminDeleteJobTitleRequest: {
          fields: {
            id: {
              type: 'int32',
              id: 1
            }
          }
        },
        TSAdminDeleteJobTitleResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            }
          }
        },
        TSAdminUpdateJobTitleRequest: {
          fields: {
            id: {
              type: 'int32',
              id: 1
            },
            status: {
              type: 'int32',
              id: 2
            },
            title: {
              type: 'string',
              id: 3
            }
          }
        },
        TSAdminUpdateJobTitleResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            jobTitle: {
              type: 'JobTitle',
              id: 3
            }
          }
        },
        TSAdminListJobTitleRequest: {
          fields: {
            pageNum: {
              type: 'int32',
              id: 1
            },
            pageSize: {
              type: 'int32',
              id: 2
            },
            status: {
              type: 'int32',
              id: 3
            }
          }
        },
        TSAdminListJobTitleResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            jobTitleList: {
              rule: 'repeated',
              type: 'JobTitle',
              id: 3
            },
            totalCount: {
              type: 'int32',
              id: 4
            }
          }
        },
        TSAdminCreateNewsRequest: {
          fields: {
            news: {
              type: 'News',
              id: 1
            }
          }
        },
        TSAdminCreateNewsResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            }
          }
        },
        TSAdminDeleteNewsRequest: {
          fields: {
            id: {
              type: 'int32',
              id: 1
            }
          }
        },
        TSAdminDeleteNewsResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            }
          }
        },
        TSAdminUpdateNewsRequest: {
          fields: {
            news: {
              type: 'News',
              id: 1
            }
          }
        },
        TSAdminUpdateNewsResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            news: {
              type: 'News',
              id: 3
            }
          }
        },
        TSAdminListNewsRequest: {
          fields: {
            pageNum: {
              type: 'int32',
              id: 1
            },
            pageSize: {
              type: 'int32',
              id: 2
            },
            title: {
              type: 'string',
              id: 3
            }
          }
        },
        TSAdminListNewsResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            newsList: {
              rule: 'repeated',
              type: 'News',
              id: 3
            },
            totalCount: {
              type: 'int32',
              id: 4
            }
          }
        },
        TSAdminDetailNewsRequest: {
          fields: {
            id: {
              type: 'int32',
              id: 1
            }
          }
        },
        TSAdminDetailNewsResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            news: {
              type: 'News',
              id: 3
            }
          }
        },
        TSUploadImageRequest: {
          fields: {
            imgB64: {
              type: 'string',
              id: 1
            }
          }
        },
        TSUploadImageResponse: {
          fields: {
            errorCode: {
              type: 'int32',
              id: 1
            },
            errorMsg: {
              type: 'string',
              id: 2
            },
            imageUrl: {
              type: 'string',
              id: 3
            }
          }
        }
      }
    }
  })

export { $root as default }
